import React from 'react';
import AdminInvoiceView from '../Admin/create';
import Noofinvoices from './view/IMCTable/Noofinvoices';

const ViewGeneratedInvoice = () => {
    const userData = JSON.parse(sessionStorage.getItem('user'));
    const buyerType = userData.result.data.userType;

    // const handleCount = (val) => {
    //     if (val === 'prev') {
    //         if (pageDetails.first !== true) {
    //             setPage((page) => page - 1);
    //         }
    //     }

    //     if (val === 'next') {
    //         if (pageDetails.last !== true) {
    //             setPage((page) => page + 1);
    //         }
    //     }
    // };

    // useEffect(() => {
    //     setLoading(true);
    //     setpreviousButton(true);
    //     setnextButton(true);
    //     axios.get(`${CommonConfig.dev.baseUrl}/api/auth//sinvoices/list/${selectedImc}?page=${page}&size=10&sort=id,desc`, axiosConfig).then((res) => {
    //         formatDate(res.data.content);
    //         setRows(res.data.content);
    //         setPageDetails(res.data);
    //         setLoading(false);
    //         if (res.data.first) {
    //             setpreviousButton(true);
    //             setnextButton(false);
    //         } else if (res.data.last) {
    //             setpreviousButton(false);
    //             setnextButton(true);
    //         } else {
    //             setpreviousButton(false);
    //             setnextButton(false);
    //         }
    //     });
    // }, [userToken, page]);

    // function formatDate(props) {
    //     return props.map((element) => {
    //         const tempStartDate = element.invoiceDate;
    //         const tempEndDate = element.dateModified;
    //         const pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
    //         const formatStartDate = new Date(tempStartDate.replace(pattern, '$3-$2-$1'));
    //         const formatEndDate = new Date(tempEndDate.replace(pattern, '$3-$2-$1'));
    //         element.invoiceDate = moment(formatStartDate).format('DD-MM-YYYY');
    //         element.dateModified = moment(formatEndDate).format('DD-MM-YYYY');
    //     });
    // }

    // HeadCells
    // const headcells = [
    //     { id: 'buyerName', label: 'IMC Name' },
    //     { id: 'invoiceNumber', label: 'Invoice ID' },
    //     // { id: 'invoiceDate', label: 'Invoice Date' },
    //     { id: 'totalAmount', label: 'Invoice Amount' },
    //     { id: 'dateModified', label: 'Email sent Date' },
    // ];

    // const history = useHistory();

    // const handleSearchQuery = (data) => {
    //     setSearchQuery(data);
    // };

    // const classes = useStyles();

    // filtered row based on search
    // const filteredRow = searchQuery
    //     ? rows.filter((row) => {
    //         const query = searchQuery.toLowerCase().trim();
    //         return headcells
    //             .map((col) => col.id)
    //             .some((key) => {
    //                 if (row[key]) {
    //                     return row[key].toString().toLowerCase().includes(query);
    //                 } else {
    //                     return false;
    //                 }
    //             });
    //     })
    //     : rows;

    if (buyerType === 'ADMIN' || buyerType === 'CORETEAM') {
        return <AdminInvoiceView />;
    }
    if (buyerType === 'SUPERADMIN') {
        return <Noofinvoices />
    }

    // return (
    //     <Card className="custom-table">
    //         <CardContent className="card-title-display">
    //             <Grid item xs={12} sm={8}>
    //                 <Typography className="card-title">View Generated Invoice</Typography>
    //             </Grid>
    //             <Grid item xs={12} sm={4} className="card-search">
    //                 <div className="search-field">
    //                     <SearchBox searchQuery={searchQuery} onChange={handleSearchQuery} placeholder="Search..." />
    //                 </div>
    //             </Grid>
    //         </CardContent>
    //         <CardContent className="card-table-display">
    //             {rows && filteredRow.length > 0 ? (
    //                 <>
    //                     <ActionTable
    //                         headcells={headcells}
    //                         rows={filteredRow}
    //                         post="superAdmin"
    //                         mode="view"
    //                         action
    //                         pageDetails={pageDetails}
    //                         prvnxtbt={{ prvBt: previousButton, nxtBt: nextButton }}
    //                         loading={loading}
    //                         handleCount={handleCount}
    //                     />
    //                 </>
    //             ) : (
    //                     <div className={classes.noRecord}>
    //                         <h1>No records to display</h1>
    //                     </div>
    //                 )}
    //         </CardContent>
    //     </Card>
    // );
};

export default ViewGeneratedInvoice;
